// extracted by css-extract-rspack-plugin
export default {"datepicker":"datepicker-8k1Ecu"};